import { render, staticRenderFns } from "./screen-ratio.vue?vue&type=template&id=a23d637a&scoped=true"
import script from "./screen-ratio.vue?vue&type=script&lang=js"
export * from "./screen-ratio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23d637a",
  null
  
)

export default component.exports